<ng-container *ngIf="user">
  <img *ngIf="photoURL$ | async as url; else showInitials" [src]="url" [class]="size" crossorigin>
</ng-container>

<ng-template #showInitials>
  <div [class]="size">{{initials}}</div>
</ng-template>
